module.exports = __webpack_public_path__ + "img/coursera-ch-pix.773ecb60.jpg";